import { type MantineTheme, mergeThemeOverrides } from '@mantine/core';
import type { PartialDeep } from 'type-fest';

import { ThemedMantineButton } from './Button';
import { ThemedMantineCard } from './Card';
import { ThemedMantineCheckbox } from './Checkbox';
import { ThemedMantineCode } from './Code';
import { ThemedMantineDatePickerInput } from './DatePickerInput';
import { ThemedMantineIndicator } from './Indicator';
import { ThemedMantineMenu } from './Menu';
import { ThemedMantineModal } from './Modal';
import { ThemedMantineMultiSelect } from './MultiSelect';
import { ThemedMantineNavLink } from './NavLink';
import { ThemedMantineNumberInput } from './NumberInput';
import { ThemedMantinePagination } from './Pagination';
import { ThemedMantineRadio } from './Radio';
import { ThemedMantineSelect } from './Select';
import { ThemedMantineTable } from './Table';
import { ThemedMantineTagsInput } from './TagsInput';
import { ThemedMantineText } from './Text';
import { ThemedMantineTextInput } from './TextInput';
import { ThemedMantineTitle } from './Title';
import { ThemedMantineTooltip } from './Tooltip';

export const componentsTheme: PartialDeep<MantineTheme> = mergeThemeOverrides(
  ThemedMantineButton,
  ThemedMantineTable,
  ThemedMantineTitle,
  ThemedMantineModal,
  ThemedMantineIndicator,
  ThemedMantineNavLink,
  ThemedMantineCard,
  ThemedMantineText,
  ThemedMantineSelect,
  ThemedMantineMultiSelect,
  ThemedMantinePagination,
  ThemedMantineCheckbox,
  ThemedMantineRadio,
  ThemedMantineNumberInput,
  ThemedMantineTooltip,
  ThemedMantineMenu,
  ThemedMantineTagsInput,
  ThemedMantineTextInput,
  ThemedMantineDatePickerInput,
  ThemedMantineCode,
);
